module.exports = __webpack_public_path__ + "static/media/Snapchat_Guide_Chin.8363df18.pdf";